import { render, staticRenderFns } from "./check-profile.vue?vue&type=template&id=b642fe20&lang=pug&"
import script from "./check-profile.vue?vue&type=script&lang=js&"
export * from "./check-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports